import { ChannelTitle, IndexedChannelInfo } from '@lessonup/typescript-core/domain';
import { channelRoute } from '@lessonup/typescript-core/services';
import { isUndefined } from 'lodash';
import React from 'react';
import ThumbBanner from './ThumbBanner';

interface Props {
  channel: IndexedChannelInfo | undefined;
  locale: string;
  channelPublic?: boolean;
}

const ThumbBannerChannel: React.FC<Props> = (props) => {
  const { channel, locale, channelPublic } = props;

  if (!isUndefined(channelPublic) && !channelPublic) return null;
  if (!locale || !channel?.title || !channel.name || !channel.icon) return null;
  const { name, icon, title } = channel;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- auto-generated TECH-258
  const label = ChannelTitle.localizeTitle(title, locale as any);
  return <ThumbBanner content={label} bannerLink={channelRoute({ channelSlug: name })} icon={icon} />;
};

export default ThumbBannerChannel;
